module.exports = __webpack_public_path__ + "img/et.697d959e.jpg";